import { routing } from '@/_i18n/routing'

/** Path without locale prefix, with leading slash (e.g. /akciova-ponuka). */
export function getPathWithoutLocale(pathname: string): string {
	const segments = pathname.replace(/^\//, '').split('?')[0].split('/')
	if (segments[0] && routing.locales.includes(segments[0] as (typeof routing.locales)[number])) {
		segments.shift()
	}
	return '/' + (segments.join('/') || '')
}
